﻿<template>

    <main class="main pl-3 pr-3">
        <add_on v-for="trip in get_Booking()?.trips" :trip="trip"></add_on>
    </main>

</template>

<script lang="ts" src="./add_ons.ts"></script>